export default {
    loading: {
        list: true,
        filters: true,
        types: false,
        publishers: false,
    },
    list: [],
    page: 1,
    totalPages: null,
    totalPosts: null,
    types: [],
    publishers: [],
    searchQuery: '',
    filters: [
        {
            name: 'Date from',
            apiKey: 'fromdate',
            type: 'date',
            value: '',
            state: false,
            url: '', // none, here for consistency
        },
        {
            name: 'Date to',
            apiKey: 'todate',
            type: 'date',
            value: '',
            state: false,
            url: '', // none, here for consistency
        },
        {
            name: 'Type',
            apiKey: 'publication_type',
            type: 'list',
            value: [],
            state: false,
            url: '/wp-json/rewind/v1/acf_select_choices/publication_type/',
        },
        {
            name: 'Publishers',
            apiKey: 'publication_publisher',
            type: 'list',
            value: [],
            state: false,
            url: '/wp-json/rewind/v1/acf_select_choices/publication_publisher/',
        },
        {
            name: 'Search',
            apiKey: 'search',
            type: 'search',
            value: '',
            state: false, // not needed, here for consistency
            url: '', // none, here for consistency
        },
    ],
};
